export const spaPages = [
  {
    path: "/bursa-spa",
    crumb: "Bursa Spa",
    title: "Bursa Spa | Lavenza Spa & Masaj Nilüfer",
    description: "Bursa spa deneyimi Lavenza'da: kese köpük ritüeli, klasik ve soft masajla birleşen rahatlama, sakin butik ortam. Nilüfer Konak Mahallesi, WhatsApp ile randevu.",
    eyebrow: "Spa · Ritüel · Rahatlama",
    accent: "Bursa Spa",
    h1: "Deneyimi",
    image: "/images/bursa-spa-lavenza.webp",
    imageAlt: "Hamam esintili spa köşesi, bakır tas ve köpük",
    intro: "Bursa, spa kelimesi icat edilmeden çok önce buharın, mermerin ve suyun şifasını biliyordu. Lavenza'da bu mirası bugünün ihtiyaçlarına uyarlıyoruz: kese ve köpük ritüelini masajla birleştiren, gösterişten uzak, sakin bir Bursa spa deneyimi.",
    sections: [
      {
        h2: "Bursa'da Spa Kültürünün Kökleri",
        paragraphs: [
          "Çekirge'nin kaplıcaları, tarihi hamamları ve Uludağ'ın eteklerindeki termal kaynaklarıyla Bursa, yüzyıllar boyunca dinlenmek için gelinen bir şehir oldu. Hamam sadece yıkanılan yer değil; sohbetin, sessizliğin ve bedene ayrılan vaktin mekânıydı. Bugün \"spa merkezi Bursa\" diye arayan biri aslında aynı şeyi arıyor: gündelik hayatın dışına çıkılan kısa bir süre.",
        ],
      },
      {
        h2: "Lavenza'nın Spa Yorumu",
        paragraphs: [
          "Havuz, sauna ya da buhar odası vaat etmiyoruz. Bizim spa anlayışımız iki temel üzerine kurulu: cildi yenileyen kese ve köpük ritüeli ile bedeni gevşeten masaj. Bu ikisi arka arkaya uygulandığında, büyük tesislerin sunduğu deneyimin özünü küçük ve sakin bir mekânda yaşarsınız. Bursa spa masaj kombinasyonu arayan misafirlerimizin en sık tercih ettiği akış tam da budur.",
        ],
      },
      {
        h2: "Kese & Köpük Ritüeli Nasıl İşler?",
        paragraphs: [
          "Önce cilt ılık suyla yumuşatılır. Ardından kese eldiveniyle ölü hücreler nazikçe alınır; bu aşama cildin nefes almasını sağlar ve dolaşımı canlandırır. Sonra bol, yoğun köpükle yıkama gelir: hem temizler hem de ciltte yumuşacık bir his bırakır. Ritüel tamamlandığında beden masaja hazırdır; yağların emilimi artar, kaslar daha kolay gevşer.",
        ],
        list: [
          "Ilık suyla ön hazırlık",
          "Kese ile arındırma",
          "Bol köpüklü yıkama",
          "İsteğe bağlı klasik veya soft masaj",
        ],
      },
      {
        h2: "Hangi Kombinasyon Size Uygun?",
        paragraphs: [
          "Yorgun ama cildi hassas olanlar için kese köpük + soft masaj yumuşak bir seçenektir. Haftanın gerginliğini atmak isteyenler kese köpük + klasik masajı tercih eder. Sadece cilt yenilenmesi isteyen misafirlerimiz kese köpüğü tek başına da alabilir. Hangisini seçeceğinize seans öncesi görüşmede birlikte karar veririz.",
        ],
      },
      {
        h2: "Spa Deneyimini Tamamlayan Detaylar",
        paragraphs: [
          "Sakin müzik, düşük ışık ve hoş bir koku; bunlar bizim için süs değil, deneyimin parçası. Odalar her misafirden sonra yeniden hazırlanır, havlu ve bornozlar yenidir. Telefonunuzu sessize alıp kapıyı kapattığınız anda Nilüfer'in trafiği dışarıda kalır. Bu sadelik, Bursa spa deneyimini uzun listeler yerine tek bir hisle tanımlamamızı sağlıyor: hafiflemiş çıkmak.",
        ],
      },
      {
        h2: "Randevu ve Konum",
        paragraphs: [
          "Salonumuz Nilüfer Konak Mahallesi'nde. Spa ritüeli için önceden WhatsApp'tan yazmanız, hazırlığın sizin için yapılmasını sağlar. Nilüfer'e özel spa içeriğimizi Nilüfer spa merkezi sayfasında, salon ve ulaşım bilgilerini Bursa masaj salonu sayfasında bulabilirsiniz.",
          "Kese köpük ritüeli için suyun ısıtılması ve odanın hazırlanması birkaç dakika sürdüğünden, randevu saatinize sadık kalmanız akışın aksamamasını sağlar. Geç kalacaksanız kısa bir mesaj yeterlidir; hazırlığı yeniden zamanlarız.",
        ],
      },
      {
        h2: "Hamamdan Modern Spa'ya: Neler Değişti, Neler Kaldı?",
        paragraphs: [
          "Geleneksel hamamda kese, göbek taşının üzerinde ve kalabalık içinde yapılırdı; sohbet ve paylaşım deneyimin parçasıydı. Modern spa anlayışı bunu tersine çevirdi: mahremiyet, sessizlik ve bireysel zaman ön plana çıktı. Lavenza'da bu iki dünyanın en iyi yanlarını korumaya çalışıyoruz. Kese eldiveninin dokusu, köpüğün bolluğu ve suyun ılıklığı hamamdan geldi; kapalı oda, randevulu düzen ve kişiye göre ayarlanan akış ise bugünün ihtiyacı.",
          "Değişmeyen tek şey amaç: bedeni arındırmak ve zihni yavaşlatmak. Bursa'da yaşayan biri için bu ritüel bir lüks değil, şehrin kültürel hafızasının parçasıdır. Biz onu yalnızca daha sakin bir odaya taşıdık.",
        ],
        list: [
          "Hamamdan kalan: kese, bol köpük, ılık su",
          "Modern spa'dan gelen: mahremiyet, randevu, sessizlik",
          "Değişmeyen: arınma ve yavaşlama",
        ],
      },
    ],
    related: [
      { label: "Nilüfer Spa Merkezi", path: "/nilufer-spa" },
      { label: "Bursa Masaj Salonu", path: "/bursa-masaj-salonu" },
      { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
      { label: "Klasik Masaj Bursa", path: "/bursa-klasik-masaj" },
      { label: "Masaj Hizmetleri", path: "/masaj-hizmetleri" },
    ],
    faq: [
      { q: "Lavenza'da havuz veya sauna var mı?", a: "Hayır. Spa deneyimimiz kese köpük ritüeli ve masaj üzerine kuruludur; havuz, sauna ya da buhar odası bulunmaz." },
      { q: "Kese köpük ne kadar sıklıkla yapılabilir?", a: "Cilt tipine göre değişir; çoğu kişi için ayda bir uygundur. Hassas ciltlerde aralığı açmak daha rahat olur." },
      { q: "Kese köpükten sonra masaj almak şart mı?", a: "Şart değil. Ritüeli tek başına alabilir ya da klasik veya soft masajla tamamlayabilirsiniz." },
      { q: "Spa ritüeli için yanımda ne getirmeliyim?", a: "Hiçbir şey. Havlu, bornoz ve kese eldiveni salonda sağlanır; yalnızca rahat kıyafetle gelmeniz yeterli." },
      { q: "Bursa spa deneyimini hediye edebilir miyim?", a: "Bir yakınınız adına randevu oluşturabilirsiniz; detayları WhatsApp'tan konuşup planlayalım. Hediye alan kişinin tercih ettiği gün ve uygulamayı sonradan kendisi de bize yazarak değiştirebilir." },
    ],
  },
  {
    path: "/nilufer-spa",
    crumb: "Nilüfer Spa Merkezi",
    title: "Nilüfer Spa Merkezi | Lavenza Konak Bursa",
    description: "Nilüfer spa merkezi arayanlara Lavenza: günlük stresi bırakmak için kese köpük ve masaj kombinasyonları, sakin ortam, Konak Mahallesi'nde merkezi konum. WhatsApp randevu.",
    eyebrow: "Nilüfer · Spa · Günlük Rutin",
    accent: "Nilüfer Spa",
    h1: "Merkezi",
    image: "/images/nilufer-spa-lavenza.webp",
    imageAlt: "Mumlar ve bitki çayı ile dinlenme köşesi",
    intro: "Nilüfer'de yaşamak demek kampüs, plaza, alışveriş caddesi ve trafik arasında geçen dolu günler demek. Lavenza, Konak Mahallesi'nde bu günlerin arasına sıkıştırılabilecek küçük ama etkili bir spa molası sunar: gösterişli değil, gerçekten dinlendirici.",
    sections: [
      {
        h2: "Nilüfer'in Temposu ve Bedende Bıraktığı İz",
        paragraphs: [
          "Sabah FSM Bulvarı'nda trafik, gündüz ekran karşısında saatler, akşam alışveriş ve ev koşturması. Bu döngü omuzları yukarı çeker, nefesi sıklaştırır, uykuyu bölmeye başlar. Nilüfer spa merkezi arayan misafirlerimizin çoğu aslında tek bir şey istiyor: bir saat boyunca hiçbir şey yapmamak. Lavenza'nın tüm düzeni bu bir saati korumak üzerine kurulu.",
        ],
      },
      {
        h2: "Günlük Rutine Sığan Spa Molaları",
        paragraphs: [
          "Spa için bütün bir gün ayırmanız gerekmiyor. Öğle arasına sığan kısa bir soft masaj, iş çıkışı kese köpükle başlayıp klasik masajla biten bir akşam ya da hafta sonu sabahı sakin bir seans; hepsi mümkün. Gece 04:00'e kadar açık olmamız, vardiyalı çalışan Nilüferliler için de planlamayı kolaylaştırıyor.",
        ],
        list: [
          "Öğle arası: kısa soft masaj",
          "İş çıkışı: kese köpük + klasik masaj",
          "Hafta sonu: yavaş tempolu tam seans",
          "Gece saatleri: sessiz salon, sakin ritim",
        ],
      },
      {
        h2: "Hizmet Kombinasyonları",
        paragraphs: [
          "Stres kaynaklı gerginlik için kese köpük sonrası soft masaj, cildi yenilerken zihni de yavaşlatır. Fiziksel yorgunluk ağır basıyorsa köpük ritüelinin ardından klasik masaj daha uygundur. Belirli bir bölgede sertlik varsa medikal masaj tek başına ya da kısa bir köpük hazırlığıyla planlanabilir. Kombinasyonu seans öncesinde kısa bir görüşmeyle belirleriz.",
        ],
      },
      {
        h2: "Konak Mahallesi'nde Sakin Bir Adres",
        paragraphs: [
          "Lavenza, Nilüfer'in kalabalık caddelerinin hemen yanında ama içeri girdiğinizde bunu hissetmezsiniz. Az sayıda oda, düşük ışık, yumuşak müzik. Bekleme salonu kalabalığı yok; randevu saatinizde gelir, doğrudan odanıza geçersiniz. Beşevler, Özlüce, İhsaniye ve Görükle'den gelen misafirlerimiz için ulaşım birkaç dakikadan çeyrek saate kadar sürüyor.",
        ],
      },
      {
        h2: "Spa Molasından En İyi Şekilde Yararlanmak",
        paragraphs: [
          "Seans öncesi telefonunuzu sessize almanızı, sonrasında ise mümkünse hemen yoğun bir işe koşmamanızı öneririz. Bol su için, o akşam erken yatmayı deneyin. Spa'nın etkisi yalnızca odada geçen sürede değil, sonrasındaki birkaç saatte de sürer; bu süreyi kendinize ayırmak farkı katlar.",
        ],
      },
      {
        h2: "Randevu",
        paragraphs: [
          "Nilüfer'de spa molası için WhatsApp'tan yazmanız yeterli; uygun saatleri paylaşır, tercih ettiğiniz kombinasyonu hazırlarız. Şehir geneline dair spa içeriğimiz Bursa spa sayfasında, salon ve ulaşım bilgileri ise Nilüfer masaj salonu sayfasında yer alıyor.",
          "İlk kez spa ritüeli deneyecekseniz \"daha önce kese yaptırmadım\" notunu eklemeniz yeterli; kese basıncını hafif tutar ve her adımı önceden anlatırız. Düzenli gelen misafirlerimiz içinse tercih ettikleri akış kayıtlıdır, tekrar anlatmanız gerekmez.",
        ],
      },
      {
        h2: "Mevsimlere Göre Spa Molası",
        paragraphs: [
          "Bursa'nın iklimi mevsimden mevsime belirgin değişir ve beden buna tepki verir. Kış aylarında soğuk, omuzları kasar ve cildi kurutur; bu dönemde kese köpük ile ardından ılık yağla yapılan klasik masaj özellikle iyi gelir. İlkbaharda enerji yükselir ama alerji ve uyku düzensizliği artar; soft masaj bu geçişi yumuşatır.",
          "Yaz sıcağında Nilüfer'in sokakları ağırlaşır; serin bir odada yavaş tempolu bir seans, günün en iyi saati olabilir. Sonbahar ise yeni iş temposunun başladığı, sırt ve boyun yoğunluğunun arttığı dönem; medikal masaj çoğu misafirimizin bu aylardaki tercihi oluyor. Mevsim ne olursa olsun, salonun içindeki sıcaklık ve ışık her zaman sizin konforunuza göre ayarlanır.",
        ],
        list: [
          "Kış: kese köpük + klasik masaj",
          "İlkbahar ve yaz: soft masaj, yavaş tempo",
          "Sonbahar: bölgesel medikal çalışma",
        ],
      },
    ],
    related: [
      { label: "Bursa Spa", path: "/bursa-spa" },
      { label: "Nilüfer Masaj Salonu", path: "/nilufer-masaj-salonu" },
      { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
      { label: "Nilüfer'de Masaj Seçimi", path: "/nilufer-masaj" },
      { label: "İletişim & Randevu", path: "/iletisim" },
    ],
    faq: [
      { q: "Nilüfer'de öğle arasına sığacak bir spa seçeneği var mı?", a: "Evet. Kısa bir soft masaj öğle arasına rahatlıkla sığar; saat için WhatsApp'tan yazmanız yeterli." },
      { q: "Spa molası için önceden ne kadar süre önce randevu almalıyım?", a: "Aynı gün için de yer bulunabilir ancak akşam ve hafta sonu saatleri için bir iki gün önceden yazmanız daha güvenli." },
      { q: "Çiftler ya da arkadaşlar birlikte gelebilir mi?", a: "Ardışık randevular planlayabiliriz. Eş zamanlı seans talebinizi WhatsApp'tan iletin, uygunluğa göre düzenleriz." },
      { q: "Nilüfer spa merkezinizde hangi ürünler kullanılıyor?", a: "Cilt dostu masaj yağları ve hamam tipi köpük kullanıyoruz. Bilinen bir alerjiniz varsa seans öncesi mutlaka paylaşın." },
      { q: "Spa sonrası aynı gün spor yapabilir miyim?", a: "Hafif yürüyüş sorun olmaz; ağır antrenmanı bir sonraki güne bırakmanızı öneririz." },
    ],
  },
];
